<template>
    <div class="footer-container mt-1 w-100">
        <h1 class="footer m-0">For support, call the Service Desk at <u>{{ serviceDeskNumber }}</u> or email <a class="link"
            href="mailto:enterprise.vc.support@autodesk.com">{{ serviceDeskEmail }}</a><span v-if="currentStep === 3 && isContingent"> or <a class="link"
                href="https://autodesk.enterprise.slack.com/archives/C1VD4HM2R" target="_blank">adsk-ask-servicedesk</a></span>.</h1>
        <h2 class="footer-sub-header m-0 mt-2 mb-3">About identity verification for Autodeskers</h2>
        <p class="footer-content">Autodesk uses an automated process to verify the identities of Autodesk workers when
            changes need to be made to their Autodesk account credentials to gain access to Autodesk systems.</p>
        <p class="footer-content">To help minimize risk and prevent security incidents, Autodesk uses an automated
            identity verification tool called Nametag to enhance efficiency, accuracy and security across identity
            verification process.</p>
    </div>
</template>

<script>
export default {
    name: "IdentityVerificationFooter",
    props: {
        currentStep: {
            type: Number,
            required: true
        },
        serviceDeskNumber: {
            type: String,
            required: true
        },
        serviceDeskEmail: {
            type: String,
            required: true
        },
        isContingent: {
            type: Boolean,
            required: true
        }
    }
};
</script>

<style scoped>
.footer-container {
    max-width: 1200px;
    padding: 0px 30px;
    margin-bottom: 60px;
    margin-top: 30px !important;
    border-top: 1px solid #ece8e8;
    padding-top: 30px;
}

.footer {
    font-size: 16px;
    font-weight: 100;
    color: black;
    font-family: artifaktElementBold;
    line-height: 34px;
}

.footer-sub-header {
    font-size: 16px;
    font-weight: 900;
    color: black;
    font-family: artifaktElementBold;
}

.footer-content {
    font-size: 14px;
    font-family: artifaktElementRegular;
    text-align: justify;
    color: black;
}

.link {
    color: #000000 !important;
    word-break: break-all;
    text-decoration: underline;
}

@media (max-width: 700px) {
    .footer-container {
        padding: 20px;
        margin-bottom: 30px;
        margin-top: 0px !important;
    }

    .footer {
        line-height: 24px;
        font-size: 14px;
        margin-bottom: 20px !important;
    }
    .footer-sub-header {
        display: none;
    }
}
</style>